import {
  CalendarIcon,
  CheckBox,
  DropDownIcon,
  EmailAtTheRateIcon,
  FileAttachmentIcon,
  HeartFilledIcon,
  LinearScaleIcon,
  ParagraphIcon,
  PhoneIcon,
  RadioBox,
  ShortTextIcon,
  SmileyIcon,
  StarFilledIcon,
  StarRatingIcon,
} from '@sketchnote/icons';
import cn from 'classnames';
import React, { Fragment } from 'react';

export const IconLabels = ({
  labelName,
  children,
}: {
  labelName: string;
  children: React.ReactNode;
}) => {
  return (
    <Fragment>
      <div className="flex align-center">
        <span
          className={cn('text-gray-400 px-4 py-2  mr-4 w-24 h-24', {
            'border rounded-sm  border-gray-200 ': !['Smiley', 'Star', 'Heart'].includes(labelName),
          })}
        >
          {children}
        </span>{' '}
        <span className="text-gray-999 text-md ">{labelName}</span>
      </div>{' '}
    </Fragment>
  );
};

export const styleoption = [
  {
    value: 'smile',
    label: (
      <div className="flex">
        <SmileyIcon className="text-gray-200 text-sm block mt-1" size={18} />
        <p className="ml-4">Smiley</p>
      </div>
    ),
  },
  {
    value: 'star',
    label: (
      <div>
        <StarFilledIcon className="text-blue-700 text-base block" /> Star
      </div>
    ),
  },
  {
    value: 'heart',
    label: (
      <div className="flex">
        <HeartFilledIcon className="text-gray-200 -mt-1" width={14} height={24} />
        <p className="ml-4">Heart</p>
      </div>
    ),
  },
];

export const options = [
  {
    value: 'short-text',
    label: (
      <IconLabels labelName={'Short text'}>
        <ShortTextIcon />
      </IconLabels>
    ),
  },
  {
    value: 'paragraph',
    label: (
      <IconLabels labelName={'Paragraph'}>
        <ParagraphIcon />
      </IconLabels>
    ),
  },
  {
    value: 'linear-scale',
    label: (
      <IconLabels labelName={'Linear scale'}>
        <LinearScaleIcon />
      </IconLabels>
    ),
  },
  {
    value: 'star-rating',
    label: (
      <IconLabels labelName={'Star rating'}>
        <StarRatingIcon />
      </IconLabels>
    ),
  },
  {
    value: 'radio-box',
    label: (
      <IconLabels labelName={'Radio box'}>
        <RadioBox />
      </IconLabels>
    ),
  },
  {
    value: 'checkbox',
    label: (
      <IconLabels labelName={'Checkbox'}>
        <CheckBox />
      </IconLabels>
    ),
  },
  {
    value: 'dropdown',
    label: (
      <IconLabels labelName={'Dropdown'}>
        <DropDownIcon />
      </IconLabels>
    ),
  },
  {
    value: 'phone',
    label: (
      <IconLabels labelName={'Phone'}>
        <PhoneIcon className="text-sm" />
      </IconLabels>
    ),
  },
  {
    value: 'email',
    label: (
      <IconLabels labelName={'Email'}>
        <EmailAtTheRateIcon />
      </IconLabels>
    ),
  },
  {
    value: 'date-picker',
    label: (
      <IconLabels labelName={'Date Picker'}>
        <CalendarIcon />
      </IconLabels>
    ),
  },
  {
    value: 'upload',
    label: (
      <IconLabels labelName={'Attachment'}>
        <FileAttachmentIcon />
      </IconLabels>
    ),
  },
];

export const fieldType = {
  email: 'Email',
  phone: 'Phone',
  dropdown: 'Dropdown',
  'radio-box': 'Radio box',
  'star-rating': 'Star rating',
  'linear-scale': 'Linear scale',
  'short-text': 'Short text',
  paragraph: 'Paragraph',
  'date-picker': 'Date Picker',
};
